import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Panel from './Panel';
import { Provider } from '../Sticky/context';

var Wrapper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Wrapper, _PureComponent);

  var _super = _createSuper2(Wrapper);

  function Wrapper() {
    _classCallCheck(this, Wrapper);

    return _super.apply(this, arguments);
  }

  _createClass(Wrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          id = _this$props.id,
          other = _objectWithoutProperties(_this$props, ["active", "id"]);

      return (
        /*#__PURE__*/
        React.createElement(Provider, {
          value: {
            needResetPostion: id === active
          }
        },
        /*#__PURE__*/
        React.createElement(Panel, Object.assign({}, other, {
          isActive: id === active
        })))
      );
    }
  }]);

  return Wrapper;
}(PureComponent);

export default Wrapper;